import { getOperationGroupMapping } from "../../../../../actions/Utilities/EmailRecipient";
import { useQuery } from "react-query";

export default function useOpsGroupMapping() {
  return useQuery("GetOperationGroupMapping", getOperationGroupMapping, {
    refetchOnWindowFocus: false,
  });
}
